module.exports = __webpack_public_path__ + "img/mycard_bg.4f08edff.jpg";